if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      const endDate = new Date(this.dataset.end);

      if (Number.isNaN(endDate.getTime()) || endDate.getTime() <= Date.now()) {
        this.dispatchEvent(new CustomEvent('countdown:expired', { bubbles: true }));
        return;
      }

      this.endDate = endDate;
      this.daysEl = this.querySelector('[data-countdown-days]');
      this.hoursEl = this.querySelector('[data-countdown-hours]');
      this.minutesEl = this.querySelector('[data-countdown-minutes]');
      this.secondsEl = this.querySelector('[data-countdown-seconds]');

      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    tick() {
      const remaining = this.endDate.getTime() - Date.now();

      if (remaining <= 0) {
        clearInterval(this.timer);
        this.dispatchEvent(new CustomEvent('countdown:expired', { bubbles: true }));
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      this.daysEl.textContent = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
      this.hoursEl.textContent = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, '0');
      this.minutesEl.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      this.secondsEl.textContent = String(totalSeconds % 60).padStart(2, '0');
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
